export type MenuItem = {
  label: string
  href: string
  children?: MenuItem[]
}

export const ticketMarketplacePath = '/events/upcoming'
export const aadFundUrl = 'https://africaartsnetwork.com/aad-fund/'
export const donatePaymentUrl = 'https://paystack.com/pay/africa-arts-network'
export const supportEmail = 'support@africanartnetwork.org'
export const supportPhone = '+233 059 555 5981'
export const supportPhoneHref = '+2330595555981'

export const menu: MenuItem[] = [
  { label: 'HOME', href: '/' },
  {
    label: 'ABOUT AAN',
    href: '/about',
    children: [
      { label: 'AAN VISION & MISSION', href: '/about#vision' },
      { label: 'AAN TEAM', href: '/about/team' },
      { label: 'CONTACT US', href: '/contact' },
    ],
  },
  {
    label: 'PROJECTS & INITIATIVES',
    href: '/projects',
    children: [
      { label: 'AAN PRODUCTIONS', href: '/projects/aan-productions' },
      { label: 'AAN EVENTS', href: ticketMarketplacePath },
      { label: 'AAN EDUC8', href: '/projects/aan-educ8' },
      { label: 'TALENT AFRICA.NET', href: '/projects/talent-africa' },
      { label: 'ADINKRA EXPERIENCE', href: '/projects/adinkra-experience' },
      { label: 'SANKOFA EPISODE', href: '/projects/sankofa-episode' },
      { label: 'AECINEMAX', href: '/projects/aecinemax' },
      { label: 'AAD FUND', href: '/projects/aad-fund' },
    ],
  },
  {
    label: 'JOIN AAN',
    href: '/join',
    children: [
      { label: 'PARTNERS', href: '/join/partners' },
      { label: 'VOLUNTEERS', href: '/join/volunteers' },
      { label: 'MEMBERS', href: '/join/members' },
    ],
  },
  {
    label: 'EVENTS',
    href: ticketMarketplacePath,
    children: [
      { label: 'UPCOMING EVENTS', href: '/events/upcoming' },
      { label: 'PAST EVENTS', href: '/events/past' },
    ],
  },
  { label: 'DONATE', href: '/donate' },
]

export const footerMenu = ['HOME', 'ABOUT AAN', 'PROJECTS AND INITIATIVES', 'JOIN AAN', 'DONATE']

export const footerMenuLinks: Record<string, string> = {
  HOME: '/',
  'ABOUT AAN': '/about',
  'PROJECTS AND INITIATIVES': '/projects',
  'JOIN AAN': '/join',
  DONATE: '/donate',
}

export const footerProjectLinks: MenuItem[] = [
  { label: 'AAN PRODUCTIONS', href: '/projects/aan-productions' },
  { label: 'AAN EVENTS', href: ticketMarketplacePath },
  { label: 'AAN EDUC8', href: '/projects/aan-educ8' },
  { label: 'TALENTAFRICA.NET', href: '/projects/talent-africa' },
  { label: 'ADINKRA EXPERIENCE', href: '/projects/adinkra-experience' },
]

export const footerJoinLinks: MenuItem[] = [
  { label: 'Partnership: Collaborate to transform the Arts', href: '/join/partners' },
  { label: 'AAN Volunteers: Make a Difference with AAN', href: '/join/volunteers' },
  { label: 'Membership: Join the AAN Community', href: '/join/members' },
  { label: 'Donate: Support the Future of Arts in Africa', href: '/donate' },
]
